import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';

const ConductorDetalleModal = ({ show, onHide, conductorId, permisos, fetchConductor, conductor, onUpdate, loading, empresas }) => {
  const [editMode, setEditMode] = useState(false);
  const [form, setForm] = useState({});

useEffect(() => {
  if (show && conductorId) {
    fetchConductor(conductorId);
    setEditMode(false);
  }
  // Solo cuando se abre el modal y cambia el id
  // eslint-disable-next-line
}, [show, conductorId]);

  useEffect(() => {
    if (conductor) {
      setForm({ 
        ...conductor,
        empresa_id: conductor.empresa?.id || null
      });
    }
  }, [conductor]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ 
      ...prev, 
      [name]: name === 'empresa_id' ? (value ? parseInt(value) : null) : value 
    }));
  };

  const handleEdit = () => setEditMode(true);
  const handleCancel = () => {
    setEditMode(false);
    setForm({ 
      ...conductor,
      empresa_id: conductor.empresa?.id || null
    });
  };
  const handleSave = () => {
    if (onUpdate) {
      // Preparar los datos para enviar al backend
      const updateData = {
        email: form.email,
        telefono: form.telefono,
        empresa_id: form.empresa_id
      };
      onUpdate(conductorId, updateData);
    }
    setEditMode(false);
  };

  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Detalles de Conductor</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: '180px' }}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Cargando...</span>
            </div>
          </div>
        ) : conductor ? (
          <Form>
            <div className="mb-4">
              <h5 className="mb-3">Información Básica</h5>
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-2">
                    <Form.Label>Nombre</Form.Label>
                    <Form.Control value={form.nombre || ''} disabled size="sm" />
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label>Apellido</Form.Label>
                    <Form.Control value={form.apellido || ''} disabled size="sm" />
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label>Rut</Form.Label>
                    <Form.Control value={form.rut || ''} disabled size="sm" />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-2">
                    <Form.Label>Email</Form.Label>
                    <Form.Control name="email" value={form.email || ''} onChange={handleChange} disabled={!editMode} size="sm" />
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label>Teléfono</Form.Label>
                    <Form.Control name="telefono" value={form.telefono || ''} onChange={handleChange} disabled={!editMode} size="sm" />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-2">
                    <Form.Label>Empresa</Form.Label>
                    {editMode ? (
                      <Form.Select
                        name="empresa_id"
                        value={form.empresa_id || ''}
                        onChange={handleChange}
                        size="sm"
                      >
                        <option value="">Seleccione una empresa</option>
                        {empresas?.map(empresa => (
                          <option key={empresa.id} value={empresa.id}>
                            {empresa.sigla}
                          </option>
                        ))}
                      </Form.Select>
                    ) : (
                      <Form.Control value={form.empresa?.sigla || ''} disabled size="sm" />
                    )}
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label>Usuario Movil</Form.Label>
                    <Form.Control value={form.empresa?.usuario_movil || ''} disabled size="sm" />
                  </Form.Group>
                </Col>
              </Row>
            </div>
            <div className="mb-4">
              <h5 className="mb-3">Vehículos Asociados</h5>
              <Row>
                <Col>
                  {form.vehiculos && form.vehiculos.length > 0 ? (
                    <ul>
                      {form.vehiculos.map(v => (
                        <li key={v.id}>{v.patente}</li>
                      ))}
                    </ul>
                  ) : (
                    <span>No tiene vehículos asociados</span>
                  )}
                </Col>
              </Row>
            </div>
            <div>
              <h5 className="mb-3">Tipo de Documento</h5>
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-2">
                    <Form.Label>Tipo</Form.Label>
                    <Form.Control value={form.tipo_documento?.documento || ''} disabled size="sm" />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-2">
                    <Form.Label>Impuesto</Form.Label>
                    <Form.Control value={form.tipo_documento?.impuesto || ''} disabled size="sm" />
                  </Form.Group>
                </Col>
              </Row>
            </div>
          </Form>
        ) : (
          <div>Cargando datos...</div>
        )}
      </Modal.Body>
      <Modal.Footer>
        {permisos.canEdit || permisos.canAdmin ? (
          editMode ? (
            <>
              <Button variant="secondary" onClick={handleCancel}>Cancelar</Button>
              <Button variant="primary" onClick={handleSave}>Guardar</Button>
            </>
          ) : (
            <Button variant="warning" onClick={handleEdit}>Editar</Button>
          )
        ) : null}
        <Button variant="outline-dark" onClick={onHide}>Cerrar</Button>
      </Modal.Footer>
    </Modal>
  );
};

ConductorDetalleModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  conductorId: PropTypes.number,
  permisos: PropTypes.object.isRequired,
  fetchConductor: PropTypes.func.isRequired,
  conductor: PropTypes.object,
  onUpdate: PropTypes.func,
  loading: PropTypes.bool,
  empresas: PropTypes.array,
};

export default ConductorDetalleModal;
